
export function setUser(user){
    
    return {
        type:'SETUSER',
        user
    }
}